import type { SelectHTMLAttributes } from "react";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: { value: string; label: string }[];
  error?: string;
}

export default function Select({
  label,
  options,
  error,
  id,
  className = "",
  ...props
}: SelectProps) {
  const selectId = id ?? label.toLowerCase().replace(/\s+/g, "-");
  return (
    <div className={className}>
      <label
        htmlFor={selectId}
        className="mb-1.5 block text-base font-medium text-text"
      >
        {label}
      </label>
      <select
        id={selectId}
        className={`w-full rounded-xl border bg-surface px-4 py-3 text-base text-text focus:outline-none focus:ring-2 focus:ring-border-focus ${
          error ? "border-error" : "border-border"
        }`}
        {...props}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-error">{error}</p>}
    </div>
  );
}
